<template>
  <div>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card>
      <v-alert
        color="purple darken-2"
        type="warning"
        icon="mdi-hand-back-left"
        prominent
        text
        class="rounded-bl-0 rounded-br-0"
      >
        <h5>{{ $t('forms.info.modifyExpirationDateForm.title') }}</h5>
        <div v-html="$t('forms.info.modifyExpirationDateForm.message')"></div>
        <v-divider
          class="my-4 info"
          style="opacity: 0.22"
        ></v-divider>
        <v-row>
          <v-col
            class="text-center"
            justify="space-around"
          >
            <v-btn
              color="purple darken-4"
              outlined
              :to="`/researchers/${data.object_id}/forms/modifyVinculationForm`"
            >
              {{ $t('forms.info.modifyExpirationDateForm.button') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-form class="pa-6" ref="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="investigator.account.expiration_date"
                  :label="$t('label.expirationDate')"
                  prepend-inner-icon="event"
                  readonly
                  outlined
                  v-on="on"
                  :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="investigator.account.expiration_date"
                @input="menu = false"
                :readonly="disabledForm"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-divider />
        <UserFormActions
          form_name_text="Modify expieration date"
          :form_name="form_name"
          :refForm="$refs.form"
          :object_type="object_type"
          :data="data"
          :state="state"
          @change-state="changeState"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import investigatorData from "../../../mixins/investigator_data";
export default {
  mixins: [changeState, validationRules, investigatorData],
  components: { UserFormActions, RejectCommentLayout },
  name: "ModifyExpirationDate",

  computed: {
    updateVinculationForm() {
      return this.$route.meta.updateForm;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    data() {
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            account: {
              expiration_date: this.investigator.account.expiration_date
            }
          }
        }
      };
    }
  },

  created() {
    this.getData();
  },

  data: () => ({
    menu: false,
    object_type: "investigator",
    form_name: "modifyExpirationDateForm",
    state: "",
    reject_comment: ""
  }),

  methods: {
    getData() {
      let path = "";
      if (this.updateVinculationForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.investigator.account = response.data.data.user.account;
            this.state = response.data.state;
            this.form_name = response.data.form_name;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigatorName(
              this.$store.state.endpoint + "/person/" + this.investigator.id
            );
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorName(
          this.$store.state.endpoint + "/person/" + this.$route.params.id
        );
        this.getExpirationDate(this.$route.params.id);
      }
    },

    getExpirationDate(id) {
      let path = this.$store.state.endpoint + "/account/" + id;

      axios
        .get(path)
        .then(response => {
          if (response.data.expiration_date !== null) {
            this.investigator.account.expiration_date =
              response.data.expiration_date;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
